import { Component, OnInit, ChangeDetectionStrategy, DestroyRef, inject , signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';

import { NavigationService } from 'src/app/services/core/navigation.service';
import { MobileResolutionService } from 'src/app/services/platform/mobile-resolution.service';
import { Turn } from 'src/app/models/route';

import { TurnComponent } from './turn/turn.component';
import { NavigationRoadlanesComponent } from '../navigation-roadlanes/navigation-roadlanes.component';
import { NavigationPlanComponent } from '../navigation-plan/navigation-plan.component';
import { SpeedlimitComponent } from './speedlimit/speedlimit.component';

@Component({
  standalone: true,
  selector: 'app-navigation-hud',
  templateUrl: './navigation-hud.component.html',
  styleUrls: ['./navigation-hud.component.scss'],
  imports: [CommonModule, TurnComponent, NavigationRoadlanesComponent, NavigationPlanComponent, SpeedlimitComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationHudComponent implements OnInit {
  public readonly turn = signal<Turn | null>(null);
  public readonly turnDistance = signal<number>(0);
  public readonly roadLanesVisible = signal<boolean>(false);
  public readonly floatingInfoVisible = signal<boolean>(true);
  public readonly mobileVisiblePanel = signal<string>('');
  public readonly hasTurn = signal<boolean>(false);
  public readonly speedLimit = signal<number>(0);
  public readonly laneInfoCount = signal<number>(0);

  private readonly destroyRef = inject(DestroyRef);
  private navigation: boolean = true;

  constructor(
    public navigationService: NavigationService,
    public mobileResolutionService: MobileResolutionService
  ) {}

  ngOnInit() {
    this.navigationService.ObservableShowRoadLane.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp) => {
      if (resp != null) {
        this.roadLanesVisible.set(resp);
      }
    });

    this.navigationService.ObservableNextTurn.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp) => {
      if (resp && this.navigation) {
        this.turn.set(resp.NextTurnInstruction);
        this.turnDistance.set(Math.round(resp.NextTurnDistance));
        this.hasTurn.set(!!resp.NextTurnInstruction);
        this.laneInfoCount.set(resp.NextTurnInstruction ? resp.NextTurnInstruction.LaneInfo.length : 0);
        this.speedLimit.set(resp.SpeedLimit);
      }
    });

    this.mobileResolutionService.ObservableMobileVisiblePanel.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((panelName) => {
      if (panelName != undefined) {
        this.mobileVisiblePanel.set(panelName);
      }
    });

    this.navigationService.ObservableFloatingInfoVisible.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp) => {
      if (resp != null) {
        this.floatingInfoVisible.set(resp);
      }
    });

  }

}